import { volunteeringRequestHandler } from '../../api/http-client/request-handler'


const MissionsListService = {
  getMissionsList(params) {
    return volunteeringRequestHandler.get('mission', {
      params,
    })
      .then(({ result }) => result)
  },
  getMissionsSearch(params) {
    return volunteeringRequestHandler.get('mission/search', {
      params: {
        ...params,
        page: params.page || 1,
      },
    })
  },
}

export default MissionsListService
